import './header.css';

function Header() {
  return (
    <div id='home' className='container header-container'>
      <h3>
        Victor Barbosa
      </h3>
      <h2>Desenvolvedor Full-Stack</h2>
    </div>
  );
}
export default Header;
